"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoveringCursorButton = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const utils_1 = require("@obvio/utils");
const react_1 = require("react");
const NativeListener_1 = require("../NativeListener");
const RenderStyle = {
    cursor: 'none',
    position: 'relative',
    userSelect: 'none',
    overflow: 'hidden',
    width: '100%',
};
const StyledCursorWrapper = app_1.styled.div `
  position: absolute;
  transition: transform 0.3s;
  transform-origin: center;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  @media ${app_1.mobile} {
    display: none;
  }
`;
function HoveringCursorButton({ children, actionLeft, actionRight, render: Render, renderCursor: RenderCursor, }) {
    const mouseRef = (0, react_1.useRef)(null);
    const handleMouseMove = (0, react_1.useCallback)((event) => {
        const cursor = mouseRef.current;
        const { clientX, clientY, currentTarget } = event;
        const bound = currentTarget.getBoundingClientRect();
        if ((0, utils_1.isClickableElement)(event) && cursor) {
            cursor.style.opacity = '0';
            return;
        }
        if (cursor) {
            cursor.style.opacity = '1';
        }
        const isHalf = clientX - bound.left <= bound.width / 2;
        if (cursor) {
            const { clientWidth, style } = cursor;
            style.top = `${clientY - bound.top - clientWidth / 2}px`;
            style.left = `${clientX - bound.left - clientWidth / 2}px`;
            style.transform = `rotate(${isHalf ? -90 : 90}deg)`;
        }
    }, []);
    const handleMouseClick = (0, react_1.useCallback)((event) => {
        var _a;
        const cursor = mouseRef.current;
        const { clientX, currentTarget } = event;
        const { offsetLeft, clientWidth: outerWidth } = currentTarget;
        const isHalf = clientX - offsetLeft <= outerWidth / 2;
        const currentOpacity = cursor ? (_a = getComputedStyle(cursor)) === null || _a === void 0 ? void 0 : _a.opacity : '0';
        if (currentOpacity !== '0') {
            if (isHalf) {
                actionLeft(event);
            }
            else {
                actionRight(event);
            }
        }
    }, [actionLeft, actionRight]);
    const handleMouseOut = (0, react_1.useCallback)(() => {
        const cursor = mouseRef.current;
        if (cursor) {
            cursor.style.opacity = '0';
        }
    }, []);
    const handleMouseEnter = (0, react_1.useCallback)(() => {
        const cursor = mouseRef.current;
        if (cursor) {
            cursor.style.opacity = '1';
        }
    }, []);
    return ((0, jsx_runtime_1.jsx)(NativeListener_1.NativeListener, Object.assign({ mousemove: handleMouseMove, click: handleMouseClick, mouseleave: handleMouseOut, mouseenter: handleMouseEnter }, { children: (0, jsx_runtime_1.jsxs)(Render, Object.assign({ style: RenderStyle }, { children: [children, (0, jsx_runtime_1.jsx)(StyledCursorWrapper, Object.assign({ ref: mouseRef }, { children: (0, jsx_runtime_1.jsx)(RenderCursor, {}) }))] })) })));
}
exports.HoveringCursorButton = HoveringCursorButton;
